module.exports = __webpack_public_path__ + "static/Euroseeds.7f94c70a.svg";